// Soft green → amber → red scale for occupancy heatmaps, built from the app's own
// Material palette (#34A853 / #FBBC05 / #EA4335) rather than a harsh full-saturation
// red-only intensity ramp — easier to scan at a glance, less visual fatigue.
const GREEN = [52, 168, 83];
const AMBER = [251, 188, 5];
const RED = [234, 67, 53];

function lerp(a, b, t) {
  return a + (b - a) * t;
}

function mixColor(c1, c2, t) {
  return [Math.round(lerp(c1[0], c2[0], t)), Math.round(lerp(c1[1], c2[1], t)), Math.round(lerp(c1[2], c2[2], t))];
}

// pct: 0 (quiet) .. 1 (busy). Returns an rgba() string, softened via alpha so the
// result reads as a light tint rather than a solid, attention-grabbing block.
export function occupancyColor(pct, { minAlpha = 0.16, maxAlpha = 0.6 } = {}) {
  const clamped = Math.max(0, Math.min(1, pct));
  const [r, g, b] = clamped < 0.5 ? mixColor(GREEN, AMBER, clamped / 0.5) : mixColor(AMBER, RED, (clamped - 0.5) / 0.5);
  const alpha = minAlpha + clamped * (maxAlpha - minAlpha);
  return `rgba(${r},${g},${b},${alpha})`;
}

// A solid (non-transparent) version for things like legend swatches or chart bars.
export function occupancySolid(pct) {
  const clamped = Math.max(0, Math.min(1, pct));
  const [r, g, b] = clamped < 0.5 ? mixColor(GREEN, AMBER, clamped / 0.5) : mixColor(AMBER, RED, (clamped - 0.5) / 0.5);
  return `rgb(${r},${g},${b})`;
}
